export default __webpack_public_path__ + "68e5e92c2aa1ec958ece275efef0a078.jpg";